import { forwardRef } from "react";
import { FormControl, FormControlProps } from "./FormControl";
import { Input, InputProps } from "./Input";

type InputControlProps = Omit<InputProps, "hasError"> &
  Omit<FormControlProps, "children"> & {
    wrapperClassName?: string;
    inputWrapperClassName?: string;
    hasError?: boolean | null;
  };

export const InputControl = forwardRef<HTMLInputElement, InputControlProps>(
  (
    {
      wrapperClassName,
      inputWrapperClassName,
      hasError,
      errorMessage,
      label,
      ...props
    },
    ref,
  ) => {
    const error = hasError !== undefined ? hasError : Boolean(errorMessage);

    return (
      <FormControl
        label={label}
        name={props.name}
        errorMessage={errorMessage}
        className={wrapperClassName}
      >
        <Input
          ref={ref}
          {...props}
          hasError={error}
          wrapperClassName={inputWrapperClassName}
        />
      </FormControl>
    );
  },
);
